import React from 'react';
import styled, {css} from 'styled-components';

import {labelStyle} from '../styles/includes/forms';

const StyledComponent = styled.label`
  ${labelStyle}
`

interface props {
  htmlFor?: string
  className?: string
  children: React.ReactNode
}

export default (props:props) => (
  <StyledComponent htmlFor={props.htmlFor} className={props.className}>{props.children}</StyledComponent>
);
